import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/data/mockData";
import { Container, Section, PageHero, Overline } from "@/components/ui-blocks";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo title="About" description="A Singapore-based heritage publisher rooted in research — Ace Asia Productions celebrates South-east Asian culture through books, collectibles and multimedia." />
      <PageHero
        testId="about-hero"
        overline="Our House"
        title="A heritage publisher rooted in research."
        subtitle="Ace Asia Productions is a multi-disciplinary, research-led production house headquartered in Singapore."
      />

      <Section className="bg-[#FDFBF7]">
        <Container>
          <div className="grid lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-5">
              <div className="relative">
                <img
                  src={ASSETS.bookCoverDark}
                  alt="Ace Asia heritage volume"
                  className="w-full aspect-[4/5] object-cover"
                />
                <div className="absolute -inset-4 border border-[#6e5022]/40 pointer-events-none" />
              </div>
            </div>
            <div className="lg:col-span-7">
              <Overline>Brand Story</Overline>
              <h2 className="mt-4 font-serif-display text-4xl md:text-5xl font-light leading-tight">
                Founded by Ms Chantal Sajan.
              </h2>
              <div className="mt-6 space-y-5 text-[#4A3728] text-lg leading-relaxed">
                <p>
                  Ace Asia Productions is a multi-disciplinary research-based
                  production house headquartered in Singapore dedicated to
                  promoting South-east Asian history, heritage and culture
                  through digital content creation, publishing of books and
                  print media collectibles, product design and multimedia
                  storytelling such as podcasts, documentaries and short films.
                </p>
              </div>

              <div className="mt-10 grid sm:grid-cols-3 gap-6">
                <Pillar n="01" title="Research-led" body="Decades of journalism and field study underpin every project." />
                <Pillar n="02" title="Heritage-first" body="Centred on the communities, architectures and rituals of the region." />
                <Pillar n="03" title="Multi-disciplinary" body="From print to podcast to product design." />
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <Section className="bg-[#281a12] text-[#FDFBF7] grain relative">
        <Container className="relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <Overline className="inline-block">Singapore · 202626404G</Overline>
            <blockquote className="mt-6 font-serif-display text-3xl md:text-5xl italic leading-tight">
              &ldquo;Heritage is not a museum behind glass. It is the soil our
              future stands on.&rdquo;
            </blockquote>
            <div className="mt-6 overline text-[#946f36]">— The Ace Asia Editorial</div>
            <div className="mt-10 flex justify-center gap-3 flex-wrap">
              <Link to="/founder" data-testid="about-founder-link" className="bg-[#946f36] hover:bg-[#FDFBF7] hover:text-[#281a12] text-[#281a12] px-7 py-3.5 text-xs uppercase tracking-[0.2em] transition-colors">
                Meet the Founder
              </Link>
              <Link to="/featured-book" data-testid="about-featured-book-link" className="border border-[#946f36] text-[#946f36] hover:bg-[#946f36] hover:text-[#281a12] px-7 py-3.5 text-xs uppercase tracking-[0.2em] transition-colors">
                Featured Book
              </Link>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );
}

function Pillar({ n, title, body }) {
  return (
    <div>
      <div className="overline text-[#946f36]">{n}</div>
      <div className="font-serif-display text-2xl text-[#281a12] mt-2">{title}</div>
      <p className="mt-2 text-sm text-[#4A3728] leading-relaxed">{body}</p>
    </div>
  );
}
